export default "__VITE_ASSET__c1e797be__"